import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import Cookies from 'js-cookie';
import { getToken, getH5Token, getRefreshToken, getH5RefreshToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
// import { getQueryString } from '@/utils';
import { manageFlexible } from "@/utils/flexibleManager";
NProgress.configure({ showSpinner: false }); // NProgress Configuration
const whiteList = ['/login', '/auth-redirect', '/go', '/bind', '/sendMsg']; // no redirect whitelist
const moWhiteList = ['/mo/auth', '/mo/bind', '/mo/register', '/mo/logout'];
window.isRefreshing = false;
router.beforeEach(async (to, from, next) => {
  await manageFlexible()
  let isWeixin = to.path.indexOf('/mo') > -1;
  NProgress.start();
  document.title = getPageTitle(to.meta.title);
  let hasToken = getToken();
  let hasH5Token = getH5Token();
  let refreshToken = getRefreshToken();
  let h5RefreshToken = getH5RefreshToken();
  if (!hasToken && refreshToken) {
    if (!window.isRefreshing) {
      window.isRefreshing = true;
      const {
        access_token,
        refresh_token,
      } = await store.dispatch('user/refreshToken', { 'refresh_token': refreshToken });
      // console.log('权限', access_token)
      // eslint-disable-next-line require-atomic-updates
      window.isRefreshing = false;
      hasToken = access_token;
      refreshToken = refresh_token;
    }
  }
  if (!hasH5Token && h5RefreshToken) {
    if (!window.isRefreshing) {
      window.isRefreshing = true;
      const {
        access_token,
        refresh_token,
      } = await store.dispatch('user/refreshToken', { 'refresh_token': h5RefreshToken });
      window.isRefreshing = false;
      hasH5Token = access_token;
      h5RefreshToken = refresh_token;
    }
  }
  if (!isWeixin) {
    if (hasToken) {
      if (to.path === '/login') {
        // if is logged in, redirect to the home page
        next({ path: '/' });
        NProgress.done();
      } else {
        // determine whether the user has obtained his permission roles through getInfo
        const hasRoles = store.getters.roles && store.getters.roles.length > 0;
        if (hasRoles) {
          next();
        } else {
          try {
            // get user info
            // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
            // console.log('user/getInfo')
            const { roles } = await store.dispatch('user/getInfo');
            // console.log(roles)
            // generate accessible routes map based on roles
            const accessRoutes = await store.dispatch('permission/generateRoutes', roles);
            // dynamically add accessible routes
            router.addRoutes(accessRoutes);

            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            next({ ...to, replace: true });
          } catch (error) {
            // remove token and go to login page to re-login
            // await store.dispatch('user/refresh')
            Message.error(error || 'Has Error');
            next(`/login?redirect=${to.path}`);
            NProgress.done();
          }
        }
      }
    } else {
      /* has no token*/
      if (whiteList.indexOf(to.path) !== -1) {
        // in the free login whitelist, go directly
        next();
      } else {
        // other pages that do not have permission to access are redirected to the login page.
        next(`/login?redirect=${to.path}`);
        NProgress.done();
      }
    }
  } else {
    const { code } = to.query;
    if (code && (to.path === '/mo/auth')) {
      next();
    } else {
      if (!hasH5Token) {
        if (moWhiteList.indexOf(to.path) !== -1) {
          next();
        } else {
          Cookies.set('backUrl', window.location.href);
          next('/mo/auth');
        }
      } else {
        next();
      }
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
